
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ApplicationFormSection from './components/ApplicationFormSection';
import CompanyInfoSection from './components/CompanyInfoSection';
import HowItWorksSection from './components/HowItWorksSection';
import BenefitsSection from './components/BenefitsSection';
import FeaturesSection from './components/FeaturesSection';
import ProductExamplesSection from './components/ProductExamplesSection';
import TestimonialsSection from './components/TestimonialsSection';
import TrustSection from './components/TrustSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';

// 安心して参加できる3つの理由セクション
function SafetyReasonsSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-rose-25 via-pink-25 to-amber-25">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-gradient-to-r from-rose-100 to-pink-100 border border-rose-200 text-rose-700 px-6 py-3 rounded-full font-medium text-sm mb-6 shadow-sm">
            <div className="w-2 h-2 bg-rose-400 rounded-full mr-3 animate-pulse"></div>
            安心・安全への取り組み
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-800 mb-6" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            安心して参加できる
            <span className="bg-gradient-to-r from-rose-400 to-pink-500 bg-clip-text text-transparent">3つの理由</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" style={{ lineHeight: '1.8' }}>
            モニター友の会が多くの女性に選ばれ、信頼される理由をご紹介します
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-10 shadow-xl border border-rose-100 text-center group hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">
            <div className="w-24 h-24 bg-gradient-to-br from-rose-100 to-pink-200 rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg group-hover:shadow-xl transition-all duration-300">
              <i className="ri-shield-user-line text-4xl text-rose-500"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-6" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>女性専用コミュニティ</h3>
            <p className="text-gray-700 leading-relaxed text-lg" style={{ lineHeight: '1.8' }}>
              参加者は全員女性の方のみ。同じ立場の仲間と一緒に、安心して商品体験活動にご参加いただけます。
            </p>
          </div>

          <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-10 shadow-xl border border-amber-100 text-center group hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">
            <div className="w-24 h-24 bg-gradient-to-br from-amber-100 to-yellow-200 rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg group-hover:shadow-xl transition-all duration-300">
              <i className="ri-customer-service-2-line text-4xl text-amber-500"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-6" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>丁寧なサポート体制</h3>
            <p className="text-gray-700 leading-relaxed text-lg" style={{ lineHeight: '1.8' }}>
              専任スタッフが親身になってサポート。分からないことがあれば、いつでもお気軽にご相談ください。
            </p>
          </div>

          <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-10 shadow-xl border border-emerald-100 text-center group hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">
            <div className="w-24 h-24 bg-gradient-to-br from-emerald-100 to-green-200 rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg group-hover:shadow-xl transition-all duration-300">
              <i className="ri-lock-2-line text-4xl text-emerald-500"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-6" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>個人情報の厳重管理</h3>
            <p className="text-gray-700 leading-relaxed text-lg" style={{ lineHeight: '1.8' }}>
              プライバシーマーク取得企業として、皆さまの大切な個人情報を適切に管理・保護いたします。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

// 手書きアンケート写真セクション
function HandwrittenSurveySection() {
  return (
    <section className="py-20 bg-gradient-to-br from-white via-rose-25 to-pink-25">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-gradient-to-r from-amber-100 to-yellow-100 border border-amber-200 text-amber-700 px-6 py-3 rounded-full font-medium text-sm mb-6 shadow-sm">
            <div className="w-2 h-2 bg-amber-400 rounded-full mr-3 animate-pulse"></div>
            リアルな体験の声
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-800 mb-6" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            実際の
            <span className="bg-gradient-to-r from-amber-400 to-yellow-500 bg-clip-text text-transparent">体験レポート</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" style={{ lineHeight: '1.8' }}>
            参加者の皆さまから寄せられた、手書きの体験レポートをご紹介します
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[1, 2, 3, 4, 5, 6].map((index) => (
            <div key={index} className="bg-white/90 backdrop-blur-sm rounded-3xl p-8 border border-gray-200 shadow-xl group hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">
              <div className="aspect-[3/4] bg-gradient-to-br from-gray-50 to-rose-25 rounded-2xl border-2 border-dashed border-gray-300 flex items-center justify-center mb-6 group-hover:border-rose-300 transition-all duration-300">
                <div className="text-center text-gray-500">
                  <div className="w-16 h-16 bg-gradient-to-br from-rose-100 to-pink-200 rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                    <i className="ri-file-text-line text-3xl text-rose-500"></i>
                  </div>
                  <p className="text-base font-medium text-gray-700 mb-2">手書きアンケート{index}</p>
                  <p className="text-sm text-gray-500">画像準備中</p>
                </div>
              </div>
              <div className="text-center">
                <div className="bg-gradient-to-r from-rose-50 to-pink-50 rounded-full px-4 py-2 mb-2">
                  <p className="text-sm font-medium text-gray-700">30代女性・東京都</p>
                </div>
                <p className="text-xs text-gray-500 bg-gray-50 rounded-full px-3 py-1 inline-block">スキンケア商品体験</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-gray-200 inline-block">
            <p className="text-gray-600 text-sm flex items-center">
              <i className="ri-shield-check-line text-emerald-500 mr-2"></i>
              個人情報保護のため、お名前等は伏せて掲載しております
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

// スマホ用固定応募ボタン
function MobileFixedButton() {
  const scrollToApplication = () => {
    const element = document.getElementById('application-form-title');
    if (element) {
      const headerHeight = 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden">
      <div className="bg-white/95 backdrop-blur-md border-t border-rose-200 p-4 shadow-2xl">
        <button
          onClick={scrollToApplication}
          className="w-full bg-gradient-to-r from-rose-400 to-pink-5

          hover:from-rose-500 hover:to-pink-600 text-white font-bold py-5 px-6 rounded-full cursor-pointer transition-all duration-300 whitespace-nowrap text-lg shadow-xl flex items-center justify-center transform active:scale-95"
          style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
        >
          <i className="ri-user-add-line mr-3 text-xl"></i>
          モニター友の会に参加
        </button>
      </div>
    </div>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-rose-25 to-pink-25">
      <Header />
      <main className="pb-24 md:pb-0">
        <HeroSection />
        <TrustSection />
        <HowItWorksSection />
        <BenefitsSection />
        <FeaturesSection />
        <ProductExamplesSection />
        <HandwrittenSurveySection />
        <TestimonialsSection />
        <ApplicationFormSection />
        <CompanyInfoSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
      <MobileFixedButton />
    </div>
  );
}
